/**
 * @file automatically generated from MApp.Data.ConcatOption
 */

export enum ConcatOption {
    None = 0,
    And = 1,
    Or = 2
}
